<template>
  <div class="mainFrameContainer">
    <div class="rightBox">
      <div class="rightListBox">
        <div class="box_title">
          <p class="title">我能订货的公司</p>
        </div>
        <div class="rightLook">
          <div class="company" v-for="org in saleOrgs">
            <ul>
              <li>
                <a class="select" @click="goProduct(org.id,org.name)">
                  <div class="button">点击进入</div>
                  <p>公司简称：<span>{{org.simpleName === null?'无':org.simpleName}}</span></p>
                  <p>姓名：{{name}}</p>
                  <p>公司全称：{{org.name}}</p>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {getOrgByCustomer, getOrgBySaleMan} from "../api/system/org_sale";

export default {
  data () {
    return {
      currentUser:'',
      name:'',
      saleOrgs:[]
    };
  },
  mounted() {
    this.currentUser = this.$store.getters.currentUser
    localStorage.setItem('currentUserNumber',this.currentUser.username)
    if(this.currentUser.userType === 1){
      this.name = this.currentUser.person.name
      this.getOrgBySaleMan(this.currentUser.id)
      localStorage.setItem('currentUserName',this.name)
    }else if(this.currentUser.userType === 2){
      this.name = this.currentUser.customer.name
      this.getOrgByCustomer(this.currentUser.id)
      localStorage.setItem('currentUserName',this.name)
    }
  },
  methods: {
    goProduct(a,b){
      localStorage.setItem('orgSaleId',a)
      localStorage.setItem('saleOrgName',b)
      this.$router.push({path: '/product/buyFeed'})
    },
    getOrgBySaleMan(userNumber){
      getOrgBySaleMan({'id':userNumber}).then(res => {
        this.saleOrgs = res.data
        localStorage.setItem('orgSaleId',this.saleOrgs[0].id)
        localStorage.setItem('saleOrgName',this.saleOrgs[0].name)
        console.log(this.saleOrgs)
      }).catch({

      })
    },
    getOrgByCustomer(userNumber){
      getOrgByCustomer({'id':userNumber}).then(res => {
        this.saleOrgs = res.data
        localStorage.setItem('orgSaleId',this.saleOrgs[0].id)
        localStorage.setItem('saleOrgName',this.saleOrgs[0].name)
        console.log(this.saleOrgs)
      }).catch({

      })
    },
  },
};
</script>
<style lang="less" scoped>
  div{
    display: block;
  }
  ul, li, a, p{
    padding: 0;
    margin: 0;
    list-style-type: none;
    text-decoration: none;
  }
  .mainFrameContainer {
    position: absolute;
    top: 20px;
    left: 10px;
    bottom: 0;
    right: 0;
    overflow: hidden;
    z-index: 4;
    overflow-y: auto;
  }
  .rightBox{
    width: auto;
  }
  .rightListBox{
    padding: 18px 30px 20px 20px;
  }
  .rightLook {
    margin-bottom: 10px;
    margin-top: 15px;
    width: 100%;
    color: #6a5c5c;
    font-size: 12px;
    display: block;
  }
  a{
    display: block;
    width: 365px;
    height: 176px;
    background: #FFFFFF;
    border:1px solid #E5E5E5;
    float:left;
    margin-right: 16px;
    margin-bottom: 16px;
  }
  a:hover{
    border-color: red;
  }
  p{
    font-size: 16px;
    color: #000000;
    line-height: 22px;
    margin-bottom: 12px;
    padding-left: 30px;
    padding-right: 30px;
  }
  span{
    color: #ff1500;
  }
  .title {
    display: block;
    font-size: 24px;
    font-weight: bold;
    padding-left: 0;
  }
  .button{
    color: #FFFFFF;
    text-align: center;
    line-height: 30px;
    width: 100px;
    height: 30px;
    background: #BE1304;
    margin-bottom: 15px;
  }
</style>

